<div *transloco="let t">
  <form [formGroup]="form" (ngSubmit)="next()" bgoScrollToInvalidOnSubmit>
    <div class="pb-32">
      <div class="grid sm:grid-cols-4">
        <div class="sm:col-span-3">
          <h1 class="heading-md">{{ t('createJobRequest.jobRequestsLabel') }}</h1>
          <bgo-job-request-summary-card
            class="mt-md"
            [showBreakdown]="false"
            [offering]="
              offering || {label: repository.readJobRequestDetailState().title ?? '', type: OfferingType.OfferBased}
            "
            [priceRange]="priceRange$ | async"
            [editLink]="previousPath.sameLevelPath"
          >
          </bgo-job-request-summary-card>

          @if (formConfiguration?.skipExecutionDate) {
            <div class="mt-xl text-sm">
              <fa-icon [icon]="infoIcon"></fa-icon>
              {{ t('createJobRequest.time.emergencyExecutionDateHint') }}
            </div>
          }

          @if (!formConfiguration?.skipExecutionDate) {
            <div class="mt-2xl">
              <h3 class="heading-md">{{ t('createJobRequest.time.label') }}</h3>
              <div class="mt-md flex flex-col space-y-sm">
                @for (date of executionDates; track date) {
                  <div>
                    <cft-radio [formControl]="controls.expectedExecution" [value]="date">
                      {{ t('createJobRequest.predefinedExecutionList.' + date) }}
                    </cft-radio>
                    @if (controls.expectedExecution.value === 'ASAP' && date === 'ASAP') {
                      <div class="mt-xs ml-8 w-2/3">
                        <span class="warning" data-testid="executionDateTooSoon">{{
                          t('createJobRequest.errors.executionDateWarning')
                        }}</span>
                      </div>
                    }
                    @if (controls.expectedExecution.value === 'WITHIN_6_MONTHS' && date === 'WITHIN_6_MONTHS') {
                      <div class="mt-xs ml-8 w-2/3">
                        <span class="warning" data-testid="highDemand">{{
                          t('createJobRequest.errors.executionDateHighDemandWarning')
                        }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
              @if (controls.expectedExecution.invalid && controls.expectedExecution.touched) {
                <div class="mt-xs error">
                  {{ t('createJobRequest.time.expectedExecutionValidationError') }}
                </div>
              }
            </div>
          }
        </div>
        @if (offering?.executionAddressEnabled) {
          <div class="mt-2xl sm:col-span-3">
            <h3 class="heading-md">{{ t('createJobRequest.contact.executionAddress') }}</h3>
            <div class="mt-md md:w-1/2">
              @if (controls.executionAddress) {
                <cft-form-field>
                  <label for="executionStreetHouseNumber">
                    {{ t('createJobRequest.contact.executionStreetHouseNumber') }}
                  </label>
                  <input
                    type="text"
                    id="executionStreetHouseNumber"
                    [formControl]="executionAddressControls.streetAndHouseNumber"
                    autocomplete="off"
                    #address
                  />
                </cft-form-field>
              }
              <div class="grid gap-xs sm:grid-cols-5">
                <cft-form-field class="sm:col-span-2">
                  <label for="executionPostalCode">{{ t('createJobRequest.contact.executionPostalCode') }}</label>
                  <input
                    type="text"
                    id="executionPostalCode"
                    [formControl]="executionAddressControls.postalCode"
                    autocomplete="off"
                    data-testid="executionPostalCode"
                  />
                </cft-form-field>
                <cft-form-field class="sm:col-span-3">
                  <label for="executionCity">{{ t('createJobRequest.contact.executionLocation') }}</label>
                  <input
                    type="text"
                    id="executionCity"
                    [formControl]="executionAddressControls.locality"
                    autocomplete="off"
                    data-testid="executionCity"
                  />
                </cft-form-field>
              </div>
              @if (controls.floor) {
                <cft-form-field>
                  <label for="floor">
                    {{ t('createJobRequest.contact.floorNumber') }}
                  </label>
                  <input id="floor" type="text" [formControl]="controls.floor" />
                </cft-form-field>
              }
              @if (controls.ownership) {
                <h3 class="mt-xl heading-md">
                  {{ t('createJobRequest.ownership.label') }}
                </h3>
                <cft-radio [formControl]="controls.ownership" [value]="Ownership.Homeowner" class="mt-md block">
                  {{ t('createJobRequest.ownership.homeowner') }}
                </cft-radio>
                <cft-radio [formControl]="controls.ownership" [value]="Ownership.Tenant" class="mt-sm block">
                  {{ t('createJobRequest.ownership.tenant') }}
                </cft-radio>
                @if (controls.ownership.invalid && controls.ownership.touched) {
                  <span class="error">
                    {{ t('createJobRequest.ownership.validationError') }}
                  </span>
                }
                @if (controls.ownership.value === Ownership.Tenant) {
                  <span class="warning">
                    {{ t('createJobRequest.ownership.tenantWarning') }}
                  </span>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
    <bgo-job-request-footer
      (cancelButtonClick)="jobRequestService.askConfirmationToCloseProcess()"
      (backButtonClick)="previous()"
      [showBackButton]="true"
      [progressSteps]="progressSteps"
      [showPoweredByBuildigo]="!!agency?.logo"
    ></bgo-job-request-footer>
  </form>
</div>
